import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpsertMovePlannerLocationsMutationVariables = Types.Exact<{
  upsertableLocations: Array<Types.Locations_Insert_Input> | Types.Locations_Insert_Input;
}>;


export type UpsertMovePlannerLocationsMutation = { __typename?: 'mutation_root', insert_locations?: { __typename?: 'locations_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'locations', id: number, address?: string | null, address_line_one?: string | null, address_line_two?: string | null, city?: string | null, customer_id?: number | null, favorite: boolean, latitude?: number | null, longitude?: number | null, name?: string | null, place_id?: string | null, region_id?: number | null, state?: string | null, timezone?: string | null, zip_code?: string | null }> } | null };


export const UpsertMovePlannerLocationsDocument = gql`
    mutation upsertMovePlannerLocations($upsertableLocations: [locations_insert_input!]!) {
  insert_locations(
    objects: $upsertableLocations
    on_conflict: {constraint: locations_customer_id_address_key, update_columns: [active, address, address_line_one, address_line_two, city, customer_id, latitude, longitude, name, place_id, region_id, state, timezone, zip_code, updatedat]}
  ) {
    affected_rows
    returning {
      id
      address
      address_line_one
      address_line_two
      city
      customer_id
      favorite
      latitude
      longitude
      name
      place_id
      region_id
      state
      timezone
      zip_code
    }
  }
}
    `;
export type UpsertMovePlannerLocationsMutationFn = Apollo.MutationFunction<UpsertMovePlannerLocationsMutation, UpsertMovePlannerLocationsMutationVariables>;

/**
 * __useUpsertMovePlannerLocationsMutation__
 *
 * To run a mutation, you first call `useUpsertMovePlannerLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMovePlannerLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMovePlannerLocationsMutation, { data, loading, error }] = useUpsertMovePlannerLocationsMutation({
 *   variables: {
 *      upsertableLocations: // value for 'upsertableLocations'
 *   },
 * });
 */
export function useUpsertMovePlannerLocationsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMovePlannerLocationsMutation, UpsertMovePlannerLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMovePlannerLocationsMutation, UpsertMovePlannerLocationsMutationVariables>(UpsertMovePlannerLocationsDocument, options);
      }
export type UpsertMovePlannerLocationsMutationHookResult = ReturnType<typeof useUpsertMovePlannerLocationsMutation>;
export type UpsertMovePlannerLocationsMutationResult = Apollo.MutationResult<UpsertMovePlannerLocationsMutation>;
export type UpsertMovePlannerLocationsMutationOptions = Apollo.BaseMutationOptions<UpsertMovePlannerLocationsMutation, UpsertMovePlannerLocationsMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moveCreation/queries/upsertMovePlannerLocations.mutation.gql}
 */
export async function upsertMovePlannerLocations(
  variables: UpsertMovePlannerLocationsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpsertMovePlannerLocationsMutation['insert_locations']>
export async function upsertMovePlannerLocations(
  variables: UpsertMovePlannerLocationsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpsertMovePlannerLocationsMutation>
export async function upsertMovePlannerLocations(
  variables: UpsertMovePlannerLocationsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpsertMovePlannerLocationsMutation['insert_locations'] | UpsertMovePlannerLocationsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpsertMovePlannerLocationsMutation>(
    UpsertMovePlannerLocationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_locations
}